import { render, staticRenderFns } from "./ViewShowText.vue?vue&type=template&id=5e2b2070&scoped=true&"
import script from "./ViewShowText.vue?vue&type=script&lang=js&"
export * from "./ViewShowText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b2070",
  null
  
)

export default component.exports